import 'jquery-confirm/dist/jquery-confirm.min.css';
import 'jquery-confirm/dist/jquery-confirm.min.js';

// ------ CONFIRM ------

export const confirm = function (params) {
  $.confirm({
    title: params.title,
    content: params.content,
    confirm: params.confirm,
    cancel: params.cancel,
    confirmButton: 'Aceptar',
    cancelButton: 'Cancelar'
  });
}

// ------ DIALOG ------

export const dialog = function (params) {
  $.dialog({
    title: params.title,
    content: params.content
  });
}

// ------ ALERT ------

export const alrt = function (params) {
  $.alert({
    title: params.title,
    content: params.content,
    confirm: params.confirm,
    confirmButton: 'Aceptar'
  });
}


// WEBPACK FOOTER //
// ./src/scripts/confirm.js